import React, { useState, useEffect } from "react";

import Design from "./Design";
import {
  fetchRating,
  fetchTargets,
  fetchWeeklyRating,
  RoleEvent,
} from "../../services/benefitApi";
const Benefit = () => {
  const [weeklyData1, setWeeklyData1] = useState(null);
  const [weeklyData2, setWeeklyData2] = useState(null);
  const [rating, setRating] = useState(null);
  const [weeklyRating, setWeeklyRating] = useState(null);
  const [flag, setFlag] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      setError(null);
      try {
        const data4 = await fetchWeeklyRating();
        const data2 = await fetchTargets();
        const data3 = await fetchRating();
        setWeeklyRating(data4.data);
        console.log(data4);
        const data1 = await RoleEvent();
        setWeeklyData1(data1.data);
        setWeeklyData2(data2.data);
        setRating(data3);
      } catch (err) {
        setError(err.message);
      } finally {
      }
    };

    fetchData();
  }, [flag]);
  return (
    <div>
      <Design
        weeklyData1={weeklyData1}
        weeklyData2={weeklyData2}
        rating={rating}
        weeklyRating={weeklyRating}
        flag={flag}
        setFlag={setFlag}
      />
    </div>
  );
};

export default Benefit;
